// extracted by mini-css-extract-plugin
export var body = "_dp-0";
export var sectionHeader = "_dp-4";
export var shortcutColumns = "_dp-2";
export var shortcutList = "_dp-1";
export var shortcutSection = "_dp-3";